var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"hide-details":"","tabindex":_vm.tabdeger,"disabled":Boolean(_vm.aktif),"label":_vm.etiket,"name":_vm.name},on:{"blur":function($event){return _vm.test()},"focus":function($event){_vm.isInputActive=true}},model:{value:(_vm.displayValue),callback:function ($$v) {_vm.displayValue=$$v},expression:"displayValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }